import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_bank_info",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "bank_info",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_bank_info_button",
  "data-kt-drawer-close": "#kt_drawer_bank_info_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_bank_info",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_bank_info_header\"><h2 class=\"fw-bolder text-light my-auto\"> Trainee Bank Information Update </h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_bank_info_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_bank_info_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_bank_info_body",
  "data-kt-scroll-dependencies": "#kt_bank_info_header, #kt_bank_info_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_bank_info_scroll"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Trainee Name")
], -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Registration No.")
], -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Reference No.")
], -1)
const _hoisted_15 = { class: "fv-row mb-7" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Account Type")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Bank Name")
], -1)
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Branch Name")
], -1)
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Routing No")
], -1)
const _hoisted_24 = {
  key: 1,
  class: "row mb-7"
}
const _hoisted_25 = { class: "col-md-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mobile Banking")
], -1)
const _hoisted_27 = {
  key: 2,
  class: "row mb-7"
}
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Agent Banking")
], -1)
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Account Number")
], -1)
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Confirm Account Number")
], -1)
const _hoisted_35 = {
  class: "card-footer py-5 text-center",
  id: "kt_bank_info_footer"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_bank_info_close",
  class: "btn btn-danger me-5"
}, " Close ", -1)
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_39 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_40 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_form_item, { prop: "trainee_name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            disabled: "",
                            modelValue: _ctx.formData.trainee_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.trainee_name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_el_form_item, { prop: "registration_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            disabled: "",
                            modelValue: _ctx.formData.registration_number,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.registration_number) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_el_form_item, { prop: "reference_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            disabled: "",
                            modelValue: _ctx.formData.reference_number,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.reference_number) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Account Type",
                      modelValue: _ctx.formData.account_type,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.account_type) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeType()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Bank Account",
                          value: "Bank Account"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Bank Account")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Mobile Banking",
                          value: "Mobile Banking"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mobile Banking")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Agent Banking",
                          value: "Agent"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Agent Banking")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (_ctx.formData.account_type == 'Bank Account')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Bank",
                            modelValue: _ctx.formData.x_bank_id,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.x_bank_id) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Select Bank",
                                value: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Select Bank")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banks, (bank) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: bank.id,
                                  label: bank.bank_name,
                                  value: bank.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(bank.bank_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_el_form_item, { prop: "branch_name" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.bank_branch_name,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.bank_branch_name) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_el_form_item, { prop: "routing_no" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.bank_routing_no,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.bank_routing_no) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.account_type == 'Mobile Banking')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Bank",
                            modelValue: _ctx.formData.x_mobile_bankings_id,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.x_mobile_bankings_id) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Select Mobile Banking",
                                value: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Select Mobile Banking")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobile_banks, (mobl) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: mobl.id,
                                  label: mobl.name,
                                  value: mobl.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(mobl.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.bankType == true) & (_ctx.formData.account_type == 'Agent Banking'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Bank",
                            modelValue: _ctx.formData.x_agent_banking_id,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.x_agent_banking_id) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Select Agent Banking",
                                value: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Select Agent Banking")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agent_banks, (agent) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: agent.id,
                                  label: agent.has_agent_bank,
                                  value: agent.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(agent.bank_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_el_form_item, { prop: "account_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.bank_account_number,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.bank_account_number) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_el_form_item, { prop: "account_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.confirmaccount_no,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.confirmaccount_no) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_39, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_41
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_37)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}